import { render, staticRenderFns } from "./FeedbackDashboard.vue?vue&type=template&id=bca9f7ac&scoped=true"
import script from "./FeedbackDashboard.vue?vue&type=script&lang=js"
export * from "./FeedbackDashboard.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDashboard.vue?vue&type=style&index=0&id=bca9f7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca9f7ac",
  null
  
)

export default component.exports